import { showSelectDeleteCustomer } from './showSelectDeleteCustomer'

export function toggleShowSelectDeleteCustomer() {
  showSelectDeleteCustomer.value = !showSelectDeleteCustomer.value
}
